exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".memoListWrapper[data-v-6eaa29a2]{width:19%;float:left;border-top:1px solid #000}.memoList[data-v-6eaa29a2]{padding:10px;box-sizing:border-box;text-align:left;border-bottom:1px solid #000}.memoList[data-v-6eaa29a2]:nth-child(2n){background-color:#ccc}.memoList[data-selected=true][data-v-6eaa29a2]{background:#ccf}.memoTitle[data-v-6eaa29a2]{height:1.5em;margin:0;white-space:nowrap;overflow:hidden}.addMemoBtn[data-v-6eaa29a2]{margin-top:20px}.markdown[data-v-6eaa29a2]{float:left;width:40%;height:500px}.preview[data-v-6eaa29a2]{float:left;width:40%;text-align:left}.deleteMemoBtn[data-v-6eaa29a2]{margin:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6eaa29a2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Editor.vue
// module id = 15
// module chunks = 0